<div id="admin-wrapper">
    <app-header></app-header>
    <div class="content-wrapper">
        <app-sidebar></app-sidebar>
        <app-content-area></app-content-area>
    </div>
</div>
